import React from 'react';
import PropTypes from "prop-types";

import {styled} from '@mui/material/styles';

import MuiIconButton from '@mui/material/IconButton';

import {greyishBlue50} from "assets/jss/main";

const StyledIconButton = styled(MuiIconButton,{
    shouldForwardProp: (prop) => !['hoverColor', 'background'].includes(prop), // Empêche la transmission de ces props` au DOM
})(({ theme, hoverColor, background }) => ({
    width: '32px',
    height: '32px',
    padding: '6px',
    borderRadius: '4px',
    backgroundColor: background ? background : '#fff',
    '&:hover': {
        backgroundColor: hoverColor ? hoverColor : greyishBlue50,
    },
    '&.Mui-disabled' : {
        backgroundColor: greyishBlue50,
    }
}))

IconButton.propTypes = {
    disabled: PropTypes.bool,
    hoverColor: PropTypes.string,
    background: PropTypes.string
}

function IconButton(props) {
    return (
      <StyledIconButton {...props}>
          <div>{React.cloneElement(props.children, {
              disabled: props.disabled,
              hoverColor: props.hoverColor,
              background: props.background
          })}</div>
      </StyledIconButton>
    );
}

export default IconButton;
